import { yupResolver } from "@hookform/resolvers/yup"
import React, { useEffect, useState } from "react"
import { FormInput } from "../../wrappers/formInput"
import { useForm } from "react-hook-form"
import * as Yup from "yup"
import { DropDownInput } from "../../wrappers/selectInput"
import { Button } from "ellow-web-ui-components-library"
import * as CONSTANTS from '../../utils/CONSTANTS'
import DatepickerDefault from "../../components/datepicker"
import Styles from "./style.module.scss"
import InfoTooltip from "../../components/infoTooltip"
import { Icon } from '@iconify/react'
import StarRating from '../../components/rating'
import { getMilliSecUTC } from "../../utils/EllowUtils"
import { Error } from "@progress/kendo-react-labels"

export type CompanyForm = {
  companyName: string;
  designation: string;
  endDate: any;
  startDate: any;
  overAllRating: any;
  communication: any;
  productivity: any;
  codeQuality: any;
}

interface Props {
  onClose?: any;
  clickHandler?: any;
  loginId?: any
  action?: any;
  setUpdatedData?: any
  defaultValues?: any
  userLoginId?: any
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
const CompanyForm: React.FC<Props> = ({ onClose, clickHandler, defaultValues, loginId, userLoginId, action }) => {

  const validationSchema = Yup.object({
    companyName: Yup.string().required("Field is required"),
    designation: Yup.string().required("Field is required"),
  })

  const formOptions = { resolver: yupResolver(validationSchema) }

  const { v4: uuidv4 } = require('uuid');

  const {
    register,
    handleSubmit,
    control,
    reset,
    setValue,
    formState,
  } = useForm<CompanyForm>(formOptions)

  const [checked, setChecked] = useState<boolean>(true);
  const [startDateState, setStartDateState] = useState<any>()
  const [error, setError] = useState<{startDate?: string, endDate?: string, overAllRating?: string}>({ startDate: '', endDate: '', overAllRating: ''})

  useEffect(() => {
    
    if(defaultValues){
      reset(defaultValues)
      if (defaultValues?.startDate) {
        setStartDateState(new Date(defaultValues.startDate))
        setChecked(false)

      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onSubmit = (data: any) => {
    
    let hasError: boolean = false
    if(!data.startDate){
      error.startDate = 'Field is required'
      hasError = true
    }if(!data.endDate){
      error.endDate = 'Field is required'
      hasError = true
    }if(!data.overAllRating){
      error.overAllRating = 'Field is required'
      hasError = true
    }

    if( !hasError){
      let newdata = {
        productivity: data.productivity ? data.productivity : defaultValues ? defaultValues.subRatings.productivity : '',
        communication: data.communication ? data.communication :  defaultValues ? defaultValues.subRatings.communication : '',
        codeQuality: data.codeQuality ? data.codeQuality : defaultValues ? defaultValues.subRatings.codeQuality : '',
    }

    let values = {
        action: action,
        section: 'companyRatings',
        loginId: loginId,
        userLoginId: localStorage.getItem('loginId'),
        companyRatings: {
            companyId: defaultValues.companyId ? defaultValues.companyId : uuidv4(),
            companyRatingId: defaultValues.companyId ? defaultValues.companyRatingId : uuidv4(),
            companyName: data.companyName,
            designation: data.designation,
            overAllRating: data.overAllRating,
            "disabled":false,
            startDate: data.startDate,
            endDate: data.endDate,
            subRatings: newdata
        }
    }
    
    clickHandler(values)
    
    }else{    
      setError({...error})
    }


  };

  const handleChange = (event: any, value: string) => {
    
    if (value === "startDate" || value === "endDate") {
      setValue(value, getMilliSecUTC(event.target.value));
      if (value === "startDate") {
        setStartDateState(event.target.value)
        setChecked(false)
      }
    }else{
        setValue('startDate', event.target.value)
    }
  };

  const onCloseModal = (e: any) => {
    onClose();
  }

  return (
        <form>
          <div className="half-form-wrap small">
            <div className="form-group">
              <FormInput<CompanyForm>
                id="companyName"
                type="text"
                name="companyName"
                label="Company Name*"
                placeholder="Company Name*"
                register={register}
                errors={formState.errors}
              //   defaultValue={defaultValues.companyName}
                // onBlur={handleSubmit(onSubmitForm)}
              />
            </div>
            <div className="form-group">
              <label className="lablel">Designation*</label>
              <DropDownInput<CompanyForm>
                  name="designation"
                  data={CONSTANTS.jobRoles}
                  register={register}
                  errors={formState.errors}
                //   defaultValue={defaultValues.designation}
                  control={control}
                />
            </div>
          </div>
          <div className="half-form-wrap small">
            <div className="form-group">
              <label className="lablel">Start Date*</label>
              <DatepickerDefault
                onChange={(e: any) => {handleChange(e, "startDate"); delete error?.startDate; setError({...error})}}
                defaultValue={defaultValues && defaultValues.startDate && new Date(parseInt(defaultValues.startDate))}
              />
              <Error>{error?.startDate}</Error>
            </div>
            <div className="form-group">
              <label className="lablel">End Date*</label>
              <DatepickerDefault
                onChange={(e: any) => {handleChange(e, "endDate"); delete error?.endDate; setError({...error})}}
                defaultValue={defaultValues && defaultValues.endDate && new Date(parseInt(defaultValues.endDate))}
                min={startDateState}
                disabled={checked ? true : false}
                />
              <Error>{error?.endDate}</Error>
            </div>
          </div>
          <div className={Styles.ratingWrapper}>
            <StarRating label={'Overall Ratings'} onChange={(e: any) => setValue('overAllRating', e.value)} defaultValue={defaultValues && defaultValues.overAllRating}/>
            <Error>{error?.overAllRating}</Error>
            <InfoTooltip>
            0-20% - 1 <Icon icon="el:star" /> 
            <br/>
            21-40% - 2 <Icon icon="el:star" />
            <br/>
            41-60% - 3<Icon icon="el:star" />
            <br/>
            61-80% - 4<Icon icon="el:star" />
            <br/>
            81-100% - 5 <Icon icon="el:star" />
            </InfoTooltip>
        </div>
        <div className={Styles.ratingHead}>
        Rating
        </div>
        <div className={Styles.certificationCard}>
                        <div className={Styles.skillsRating}>Code quaility <span><StarRating defaultValue={defaultValues && defaultValues.subRatings && defaultValues.subRatings.codeQuality} onChange={(e: any) => setValue('codeQuality', e.value)}/></span></div>
                        <div className={Styles.skillsRating}>Productivity <span><StarRating defaultValue={ defaultValues && defaultValues.subRatings && defaultValues.subRatings.productivity} onChange={(e: any) => setValue('productivity', e.value)}/></span></div>
                        <div className={Styles.skillsRating}>Communication <span><StarRating defaultValue={ defaultValues && defaultValues.subRatings && defaultValues.subRatings.communication} onChange={(e: any) => setValue('communication', e.value)}/></span></div>
                        {/* <div className={Styles.skillsRating}>Ability to drive projects to success with minimal guidance<span><StarRating defaultValue={ defaultValues && defaultValues.subRatings && defaultValues.subRatings.leadership} onChange={(e: any) => setValue('leadership', e.value)}/></span></div> */}
                        {/* <div className={Styles.skillsRating}>Team player <span><StarRating defaultValue={defaultValues && defaultValues.subRatings && defaultValues.subRatings.teamPlayer} onChange={(e: any) => setValue('teamPlayer', e.value)}/></span></div> */}
        </div>
          <div className="popupAction">
            <Button onClick={(e: any) => onCloseModal(e)} variant="cancel">
            Cancel
            </Button>
            <Button onClick={handleSubmit(onSubmit)} variant="primary">
              Save
            </Button>
          </div>
        </form>
  );
};

export default CompanyForm;
